export enum TopicEnum {
  ALL = 'ALL',
  IMPOLITIC_CONTENT = 'IMPOLITIC_CONTENT',
  PIRACY_CONTENT = 'PIRACY_CONTENT',
  PIRACY_IMAGE = 'PIRACY_IMAGE',
  RUDE_LANGUAGE = 'RUDE_LANGUAGE',
  OTHER = 'OTHER',
}
